import React from 'react';
import AdminCommandCenter from '../components/admin/AdminCommandCenter';

const AdminDashboard = () => <AdminCommandCenter />;

export default AdminDashboard;
